export default "__VITE_ASSET__CFYZucwc__"